export const AUTH_COOKIE = 'Auth';

export function getCookie(name) {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
}

export function setCookie(options, value, callback) {
  if (!options.name) return '';

  const { name, ...otherOptions } = options;

  let cookie = `${name}=${value};`;
  cookie += Object.keys(otherOptions)
    .filter((key) => !!key)
    .map((key) => `${key}=${otherOptions[key]}`)
    .join(';');

  document.cookie = cookie;

  return callback && callback(cookie);
}

export function resetAuthCookie(cookieDomain, token) {
  deleteCookie(AUTH_COOKIE);

  const expirationTime = 6 * 60 * 60 * 1000; // 6 hours in milliseconds
  setCookie(
    {
      domain: `.${cookieDomain}`,
      expires: new Date(Date.now() + expirationTime).toUTCString(),
      name: AUTH_COOKIE,
      path: '/',
      sameSite: 'Lax',
      secure: true,
    },
    token
  );
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export default null;
